import { SerializedStyles, css } from "@emotion/react";

import theme from "../../styles/theme";
import { black1D, white, greyDark, greySecondary, greyLight } from "../../styles/variables";

const { spacing } = theme;

export const labelWrapper = (marginTop = 0): SerializedStyles => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${spacing(marginTop)}px;
  margin-bottom: ${spacing(1)}px;
`;

export const hint = css`
  color: ${greyDark};
`;

export const link = css`
  text-decoration: none;
`;

export const divider = css`
  margin-bottom: ${spacing(2.5)}px;
  background-color: ${greySecondary};
`;

export const rtmpBlock = css`
  label {
    color: ${black1D};
  }

  textarea {
    background-color: ${white};
    color: ${black1D};
  }
`;

export const tokenGenerator = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing(2)}px;
  margin-bottom: ${spacing(3)}px;
`;

export const tokenContent = css`
  padding: 0 ${spacing(3)}px ${spacing(6)}px;

  p {
    margin: ${spacing(2)}px 0;
  }
`;

export const tokenValue = css`
  padding: ${spacing(2)}px;
  border-radius: 4px;
  background: ${greyLight};
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.5;
`;

export const tokenMetadata = css`
  border-top: 1px solid ${greySecondary};
  padding-top: ${spacing(2)}px;
  font-size: 13px;

  > div {
    display: flex;
    justify-content: space-between;
    gap: ${spacing(2)}px;
    margin-bottom: ${spacing(1)}px;
  }

  span {
    color: ${greyDark};
  }

  strong {
    text-align: right;
  }
`;
